import React, { Component } from "react";
import "./App.css";

class App extends Component {
  state = { contactFormSubmissionInProcess: false };

  handleFormSubmit = (e, arg2) => {
    e.preventDefault();
    const firstName = e.target.firstName.value;
    const lastName = e.target.lastName.value;
    const email = e.target.email.value;
    const message = e.target.message.value;
    this.submitForm(firstName, lastName, email, message);
  };

  handleFormKeyUp = e => {
    const { contactFormSubmissionInProcess } = this.state;
    if (contactFormSubmissionInProcess) return;
    e.preventDefault();

    if (e.keyCode === 13) {
      const form = document.getElementById("contact-us-form");

      const firstName = form.firstName.value;
      const lastName = form.lastName.value;
      const email = form.email.value;
      const message = form.message.value;

      this.submitForm(firstName, lastName, email, message);
    }
  };

  submitForm = (firstName, lastName, email, message) => {
    this.setState({ contactFormSubmissionInProcess: true });
    fetch(
      "https://yhaeg8cyk4.execute-api.us-east-1.amazonaws.com/dev/contact-mapomatix",
      {
        method: "post",
        body: JSON.stringify({
          name: `${firstName} ${lastName}`,
          email,
          message
        })
      }
    )
      .then(response => {
        return response.json();
      })
      .then(data => {
        if (data.result === "Success") {
          alert(
            "Thank you for contacting us. We have received your information and will be in touch shortly."
          );
          document.getElementById("contact-us-form").reset();
          this.setState({ contactFormSubmissionInProcess: false });
        }
      })
      .catch(err => {
        console.error("err", err);
        alert(
          "There was an error submitting the form. Please send us an e-mail at contact@mapomatix.com"
        );
        this.setState({ contactFormSubmissionInProcess: false });
      });
  };

  render() {
    const { handleFormSubmit, handleFormKeyUp } = this;
    const { contactFormSubmissionInProcess } = this.state;
    return (
      <div className="App">
        <div className="navbar navbar--extended">
          <nav className="nav__mobile" />
          <div className="container">
            <div
              className="navbar__inner"
              style={{ paddingTop: "3em", paddingBottom: "3em" }}
            >
              <img src="/images/mapomatix_nav_logo.png" alt="Mapomatix logo" />
              <nav className="navbar__menu">
                <ul>
                  <li>
                    <a
                      href="#about-us-wrapper"
                      style={{ textTransform: "uppercase", letterSpacing: 1 }}
                    >
                      About
                    </a>
                  </li>
                  <li>
                    <a
                      href="#contact-us-wrapper"
                      style={{ textTransform: "uppercase", letterSpacing: 1 }}
                    >
                      Contact
                    </a>
                  </li>
                </ul>
              </nav>
              <div className="navbar__menu-mob">
                <a href="" id="toggle">
                  <svg
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                  >
                    <path
                      fill="currentColor"
                      d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
                      className=""
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="hero">
          <div className="hero__overlay hero__overlay--gradient" />
          <div className="hero__mask" />
          <div className="hero__inner">
            <div className="container">
              <div className="hero__content" style={{ textAlign: "center" }}>
                <div className="hero__content__inner">
                  <div
                    style={{
                      fontSize: "3rem",
                      marginBottom: "0.5em",
                      fontWeight: 700
                    }}
                  >
                    Your full service geospatial intelligence provider
                  </div>

                  <div style={{ fontSize: "1.4rem" }}>
                    <div style={{ marginBottom: "1em" }}>
                      Mapomatix builds custom websites, datasets and analyses
                      that are location aware, and have a rich experience in
                      visualizing, transforming and analyzing map-centric
                      datasets.
                    </div>
                    <a
                      href="#learn-more-wrapper"
                      className="button hero__button"
                      style={{ textTransform: "uppercase", letterSpacing: 1 }}
                    >
                      Learn more
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="steps landing__section" id="learn-more-wrapper">
          <div className="container">
            <h2
              className="section-headers"
              style={{
                textTransform: "uppercase",
                letterSpacing: 1
              }}
            >
              School Locator
            </h2>
          </div>
          <div className="container">
            <div className="steps__inner">
              <div className="step">
                <div className="step__media">
                  <img
                    alt="Replace this text"
                    src="./images/school_locator_screenshot.jpg"
                  />
                </div>
                <div style={{ textAlign: "left", fontSize: "1.2rem" }}>
                  <div>
                    The <b>School Locator</b> is a turnkey, easy-to-use website
                    that school districts can provide to parents and real estate
                    agents to identify the assigned school for a given address.
                    The website requires no technical set-up or knowledge from a
                    school district, and can be launched in as little as one
                    day.
                  </div>
                  <ul>
                    <li>
                      Hosted in the cloud – no need to pay for infrastructure
                    </li>
                    <li>
                      District can update its boundaries each year at no
                      additional cost
                    </li>
                    <li>
                      Admin portal for easy management and custom branding that
                      requires no technical knowledge
                    </li>
                    <li>
                      Cross-platform – works on desktops, tablets and mobile
                      phones
                    </li>
                    <li>
                      Multi-lingual - can support any other language using the
                      Google Translate API
                    </li>
                  </ul>
                  <div>
                    Are you a school official ready to setup your school
                    locator? Contact us to get started!
                  </div>
                  <br />
                  <div>
                    Would you like to see a demo? Click{" "}
                    <a className="link" href="#contact-us-wrapper">
                      here
                    </a>{" "}
                    to schedule a demo.
                  </div>
                  <br />
                  <div>
                    <a
                      className="link"
                      href="https://schoollocator.mapomatix.com/district/1737080"
                    >
                      Head over to Springfield, Illinois School District’s #186
                      to see the school locator in action.
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="steps landing__section">
          <div className="container">
            <h2
              className="section-headers"
              style={{
                textTransform: "uppercase",
                letterSpacing: 1
              }}
            >
              Datasets
            </h2>
          </div>
          <div className="container">
            <div className="steps__inner">
              <div className="step">
                <div className="step__media">
                  <img alt="Replace this text" src="./images/claritas.png" />
                </div>
                <div style={{ textAlign: "left", fontSize: "1.2rem" }}>
                  <div>
                    Mapomatix is a reseller of Claritas’ industry leading PRIZM
                    and PopFacts datasets. Mapomatix can take your customer data
                    and match it to Clartias’ PRIZM segmentation data to profile
                    your customers and identify new potential customers. We can
                    show you where your existing customers and potential
                    customers are on a map and provide a list of addresses to
                    target new potential customers.{" "}
                  </div>
                  <br />
                  <div>
                    We also have extensive experience in combining and
                    consolidating geospatial datasets focused on demographics,
                    boundaries, parcels, transportation networks, school
                    attendance boundaries and more.
                  </div>
                  <br />
                  <div>
                    Contact us to tell us about your datasets and how we can
                    support your efforts!
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="steps landing__section">
          <div className="container">
            <h2
              className="section-headers"
              style={{
                textTransform: "uppercase",
                letterSpacing: 1
              }}
            >
              Services
            </h2>
          </div>
          <div className="container">
            <div className="steps__inner">
              <div className="step">
                <div class="block">
                  <span className="service-icon-circle">
                    <i class="fas fa-map-marked-alt service-icon" />
                  </span>

                  <div>
                    <h2>
                      Geospatial data creation, consolidation and aggregation
                    </h2>
                    <p style={{ fontSize: "1.2em" }}>
                      Are you trying to understand how you can better utilize
                      data that is location centric? We compile, consolidate and
                      aggregate geospatial datasets to help companies make
                      geospatial data simple and seamless.
                    </p>
                  </div>
                </div>
                <div class="block">
                  <span className="service-icon-circle">
                    <i class="fas fa-laptop service-icon" />
                  </span>

                  <div>
                    <h2>Full-stack web application development</h2>
                    <p style={{ fontSize: "1.2em" }}>
                      Are you ready to showcase your geospatial data? We rapidly
                      develop custom, full-stack, cross-browser, map-centric
                      websites that utilize the latest open-source technologies
                      and prevent vendor lock-in.
                    </p>
                  </div>
                </div>
                <div class="block">
                  <span className="service-icon-circle">
                    <i class="fas fa-chart-line service-icon" />
                  </span>

                  <div>
                    <h2>Predictive analytics</h2>
                    <p style={{ fontSize: "1.2em" }}>
                      Are you overwhelmed with data but trying to make sense of
                      what assets can be used? We start with the business need
                      first, and then apply predictive models to create a
                      pipeline from ingestion to insights.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="steps landing__section" id="about-us-wrapper">
          <div className="container">
            <h2
              className="section-headers"
              style={{
                textTransform: "uppercase",
                letterSpacing: 1
              }}
            >
              About Us
            </h2>
          </div>
          <div className="container">
            <div className="steps__inner">
              <div className="step">
                <div className="step__media">
                  <img
                    alt="Tim Johnson "
                    src="./images/tim_headshot.jpg"
                    className="step__image"
                    style={{ maxHeight: 250 }}
                  />
                </div>
                <h4>Tim Johnson</h4>
                <p className="step__text">
                  Tim Johnson is Co-founder and CEO of Mapomatix. He has over 35
                  years of experience using geospatial technologies in both the
                  public and private sector. In 1992 he and Bob Lindquist
                  founded GIS Solutions, Inc. and Tim served as its President
                  until Spring of 2018 when he left to start Mapomatix. In
                  addition to business operations, Tim will focus on marketing
                  and product development at Mapomatix. He received a BA in
                  Economics from Saint Louis University and a MS in Urban &
                  Regional Planning from the University of Arizona.
                </p>
              </div>
              <div className="step">
                <div className="step__media">
                  <img
                    alt="Chris Walker "
                    src="./images/chris_headshot.jpg"
                    className="step__image"
                    style={{ maxHeight: 250 }}
                  />
                </div>
                <h4>Chris Walker</h4>
                <p className="step__text">
                  Chris Walker is Co-founder and GIS Product Manager at
                  Mapomatix. He has 15 years of experience in spatial analysis,
                  product development, data collection, demographics, and
                  editing and developing GIS systems. Chris brings client data
                  to life by using Mapomatix’s cutting edge geospatial
                  technologies and leads all client development efforts. He
                  graduated from Illinois State University with a BS in
                  Geography.
                </p>
              </div>
              <div className="step">
                <div className="step__media">
                  <img
                    alt="Nathan Hall "
                    src="./images/nathan_headshot.jpg"
                    className="step__image"
                    style={{ maxHeight: 250 }}
                  />
                </div>
                <h4>Nathan Hall</h4>
                <p className="step__text">
                  Nathan Hall is a full-stack developer at Mapomatix with a
                  special interest in building scalable real-time web
                  applications. He develops applications using a full Javascript
                  stack and has experience with the latest in front-end,
                  back-end and API technologies. Nathan graduated from the
                  University of Illinois-Springfield with a BA in English.
                </p>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="steps__inner">
              <div className="step">
                <div className="step__media">
                  <img
                    alt="Dylan Hall "
                    src="./images/dylan_headshot.jpg"
                    className="step__image"
                    style={{ maxHeight: 250 }}
                  />
                </div>
                <h4>Dylan Hall</h4>
                <p className="step__text">
                  Dylan Hall is a Partner at Mapomatix. Dylan has served as a
                  CTO at several venture-backed startups, with technical roles
                  including full-stack developer, data scientist, database
                  administrator and cloud architect. He specializes in building
                  the predictive models and technology stacks that support
                  spatial and time-series based business intelligence web
                  applications. Dylan is currently a Lecturer at the University
                  of Chicago’s Masters in Computer Science Program (MPCS) and
                  has an MBA from Chicago Booth and BS in Computer Science from
                  the University of Illinois in Urbana-Champaign.
                </p>
              </div>
              <div className="step">
                <div className="step__media">
                  <img
                    alt="Shima Rayej"
                    src="./images/shima_headshot.jpg"
                    className="step__image"
                    style={{ maxHeight: 250 }}
                  />
                </div>
                <h4>Shima Rayej</h4>
                <p className="step__text">
                  Shima Rayej is a Partner at Mapomatix and has extensive
                  experience developing consumer-facing technologies at both
                  startups and large financial institutions where she has held
                  roles as Chief Product Officer, front-end developer, and data
                  scientist. Shima received her BS in Computer Science and
                  Electrical Engineering from the Massachusetts Institute of
                  Technology and her MBA from the University of Chicago Booth
                  School of Business.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          className="steps steps landing__section"
          id="contact-us-wrapper"
          style={{ paddingBottom: "6em" }}
        >
          <div className="container">
            <h2
              className="section-headers"
              style={{
                textTransform: "uppercase",
                letterSpacing: 1,
                paddingBottom: "1.5em"
              }}
            >
              CONTACT US
            </h2>
          </div>
          <div className="container">
            <form
              onSubmit={handleFormSubmit}
              onKeyUp={handleFormKeyUp}
              id="contact-us-form"
            >
              <div className="double">
                <div className="half">
                  <label htmlFor="first-name">First Name</label>
                  <input
                    type="text"
                    id="first-name"
                    name="firstName"
                    autoComplete="given-name"
                    required
                  />
                </div>
                <div className="half">
                  <label htmlFor="last-name">Last Name</label>
                  <input
                    type="text"
                    id="last-name"
                    name="lastName"
                    autoComplete="family-name"
                    required
                  />
                </div>
              </div>
              <label htmlFor="email">E-mail</label>
              <input
                type="email"
                id="email"
                name="email"
                autoComplete="email"
                required
              />
              <label htmlFor="textarea">Message </label>
              <textarea id="message" name="message" />
              <button
                className="button button__accent"
                type="submit"
                style={{
                  float: "right",
                  textTransform: "uppercase",
                  letterSpacing: 1
                }}
                disabled={contactFormSubmissionInProcess}
              >
                Submit
              </button>
            </form>
          </div>
        </div>
        <div className="footer footer--dark">
          <div className="container">
            <div className="footer__inner">
              <span>Copyright © 2018 | All Rights Reserved</span>
              125 S. Clark St, 17th Floor, Chicago, IL
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js